module.exports = __webpack_public_path__ + "static/media/pdfZendy.2186fdff.png";